const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.485 18.784c.113.296.182.614.182.95a2.667 2.667 0 01-3.17 2.616 2.661 2.661 0 01-2.163 1.117H20.8c-1.067 0-1.6.533-1.6 1.6h-6.4c0-1.067-.533-1.6-1.6-1.6h-.533c-.893 0-1.68-.444-2.163-1.118A2.7 2.7 0 018 22.4a2.666 2.666 0 01-2.666-2.667c0-.335.068-.653.182-.949-.75-.472-1.25-1.3-1.25-2.25s.5-1.779 1.25-2.25a2.64 2.64 0 01-.182-.95c0-1.293.919-2.369 2.138-2.614 0-.019-.005-.035-.005-.054A2.666 2.666 0 0110.133 8c.25 0 .489.045.718.11a2.661 2.661 0 012.483-1.71A2.667 2.667 0 0116 9.067 2.667 2.667 0 0118.667 6.4a2.66 2.66 0 012.482 1.71c.23-.065.467-.11.718-.11a2.667 2.667 0 012.666 2.666c0 .02-.005.035-.005.054a2.666 2.666 0 012.139 2.613c0 .336-.07.654-.182.95.748.472 1.249 1.3 1.249 2.25s-.501 1.78-1.25 2.251M16 0c8.837 0 16 7.163 16 16 0 8.836-7.163 16-16 16-8.836 0-16-7.164-16-16C0 7.163 7.164 0 16 0zm1.067 18.667h-2.133v1.6h2.133zm-.775-7.987c-.903 0-1.635.221-2.197.664a2.477 2.477 0 00-.94 1.989h1.779c.003-.368.317-.685.541-.876.223-.191.496-.287.817-.287.391 0 .691.113.901.339.211.226.316.538.316.937 0 .361-.092.686-.277.977-.184.291-.507.509-.816.761-.524.403-.952.799-1.127 1.082-.176.282-.352.727-.355 1.334h2.133c0-.36.041-.644.123-.85s.256-.411.521-.615c.486-.317.916-.65 1.239-1.118.323-.469.533-1.039.533-1.59 0-.846-.28-1.568-.833-2.06-.554-.493-1.386-.687-2.358-.687z"
});

const SvgThink = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6fdcf8",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/think.5aa6d1b9.svg";
export { ForwardRef as ReactComponent };